<template>
  <div class="Star">
    <div class="topbar">
      <i @click="goHome" />
      <div class="mainBox1 clearfix">
        <div class="changeLangBtn" @click.stop="moreLang()">
          {{ $t('language') }}
          <em class="iconfont icon-een" ></em>
          <ul v-show="changeLangBox" class="chooseLangUl">
            <li
              v-for="(item, index) in langList"
              class="chooseLangUlli"
              :key="index"
              @click="setLanguage(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="settingBtn" @click.stop="setting()">
          {{ name ? name : names }}
          <em class="iconfont icon-een"></em>
          <ul v-show="settingBoxVis" class="chooseLangUl chooseLangUls">
            <li @click="goHome">{{ $t("myHome") }}</li>
            <li @click="toMyAccount">{{ $t("setting_1") }}</li>
            <li @click="logOut">{{ $t("setting_2") }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="mainBox">
      <div class="forgetPsd1">
        {{ $t("star_txt7") }}
      </div>

      <div class="star">
        <div class="defaultCourse" v-if="userTypeLocal == 2">
          <el-checkbox
            v-model="checked"
            @change="chooseDefaultCourse"
            :disabled="disabled"
            >{{ $t("star_txt5") }}</el-checkbox
          >
        </div>

        <div class="selects abs">
          <!-- 班级 -->
          <div class="cl_list">
            <div class="selectsClass">
              <i class="selectsIcons fl"></i>
              <div class="fl">{{ $t("star_txt2") }}</div>
              <i class="el-icon-arrow-down fl" v-if="userTypeLocal == 2"></i>
            </div>

            <el-tooltip
              class="item"
              v-if="userTypeLocal == 2"
              effect="light"
              :content="className ? className : firstClass"
              placement="left-start"
            >
              <span class="allClassNames">{{
                className ? className : firstClass
              }}</span>
            </el-tooltip>

            <el-tooltip
              class="item"
              v-if="userTypeLocal == 1"
              effect="light"
              :content="firstClass"
              placement="left-start"
            >
              <span class="allClassNames">{{ firstClass }}</span>
            </el-tooltip>

            <select
              class="classes"
              @change="search"
              v-model="temp.class"
              v-if="userTypeLocal == 2"
            >
              <option
                v-for="item in classList"
                :key="item.id"
                :label="item.className"
                :value="item.id"
              ></option>
            </select>
          </div>

          <!-- 模式选择 -->
          <div class="cl_list cl_list0">
            <div class="selectsClass">
              <i class="selectsIcons selectsIconsMode fl"></i>
              <div class="fl">{{ $t("star_txt1") }}</div>
              <i class="el-icon-arrow-down fl" v-if="userTypeLocal == 2"></i>
            </div>

            <el-tooltip
              class="item"
              effect="light"
              :content='
                temp.codeMode == 2 ? $t("modeCpp") : temp.codeMode == 1 ? $t("modeCode") : $t("modeScratch")
              '
              placement="left-start"
            >
              <span class="allClassNames">{{
                temp.codeMode == 2 ? $t("modeCpp") : temp.codeMode == 1 ? $t("modeCode") : $t("modeScratch")
              }}</span>
            </el-tooltip>

            <select
              class="classes"
              @change="searchMode"
              v-model="temp.codeMode"
              v-if="userTypeLocal == 2"
            >
              <!-- <option v-for="item in codeList" :key="item.id" :label="item.name" :value="item.id"></option> -->
              <option :label="$t('modeCode')" value="1"></option>
              <option :label="$t('modeScratch')" value="0"></option>
              <option :label="$t('modeCpp')" value="2"></option>
            </select>
          </div>

          <!-- 课程选择 -->
          <div class="cl_list cl_list1">
            <div class="selectsClass">
              <i class="selectsIcons selectsIcons1 fl"></i>
              <div class="fl">{{ $t("star_txt3") }}</div>
              <i class="el-icon-arrow-down fl" v-if="userTypeLocal == 2"></i>
            </div>

            <el-tooltip
              class="item"
              v-if="userTypeLocal == 2"
              effect="light"
              :content="courseFilter(getSelectGame(selectGameId))"
              placement="left-start"
            >
              <span class="allClassNames">{{ courseFilter(getSelectGame(selectGameId)) }}</span>
            </el-tooltip>

            <el-tooltip
              class="item"
              v-if="userTypeLocal == 1"
              effect="light"
              :content="courseFilter(getSelectGame(firstCourseId))"
              placement="left-start"
            >
              <span class="allClassNames">{{ courseFilter(getSelectGame(firstCourseId)) }}</span>
            </el-tooltip>

            <select
              class="classes"
              @change="search"
              v-model="temp.course"
              v-if="userTypeLocal == 2"
            >
              <option
                v-for="item in gameList"
                :key="item.gameId"
                :label="$t(item.gameName)"
                :value="item.gameId"
              ></option>
            </select>
          </div>

          <!-- 关卡选择  :class="{'cl_list2':userTypeLocal==2}"-->
          <div class="cl_list cl_list2">
            <div class="selectsClass">
              <i class="selectsIcons selectsIcons2 fl"></i>
              <div class="fl">{{ $t("star_txt4") }}</div>
              <i class="el-icon-arrow-down fl"></i>
            </div>

            <el-tooltip
              class="item"
              effect="light"
              :content="temp.level ? temp.level : firstLevel"
              placement="left-start"
            >
              <span class="allClassNames"
                >{{ temp.level ? temp.level : firstLevel
                }}{{ lan == "zh" ? "关" : "Levels" }}</span
              >
            </el-tooltip>

            <select class="classes" @change="search('1')" v-model="temp.level">
              <option
                v-for="item in newLevelList"
                :key="item.id"
                :label="item.level"
                :value="item.level"
              ></option>
            </select>
          </div>

          <div class="cl_list cl_list3" v-if="userTypeLocal == 2"> 
            <div class="selectsClass">
              <i class="selectsIcons selectsIcons1 fl"></i>
              <div class="fl" @click="toggleCourseMng()">{{ $t("courses_setting") }}</div>
            </div>
          </div>
        </div>

        <div class="classTables abs">
          <el-table :data="tableData" border style="width: 100%">
            <template slot="empty">
              <el-empty :image-size="100" description="No data avaiable..."></el-empty>
            </template>
            <el-table-column
              prop="name"
              align="center"
              :label="$t('star_txt6')"
            ></el-table-column>
            <el-table-column
              prop="currentStars"
              align="center"
              :label="temp.level + $t('star_txt10')"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="star"
              align="center"
              :label="$t('star_txt9')"
              width="120"
            ></el-table-column>
            <div v-for="(s, m) in starLevelList" :key="m">
              <el-table-column
                align="center"
                :label="s.level.toString()"
                width="60"
              >
                <template slot-scope="scope">
                  <div
                    class="allstars"
                    @click="getStarCode(scope.row.gameData[m], s)"
                  >
                    <img
                      v-if="!scope.row.gameData[m].play"
                      src="~@/assets/images/icons/gray_star.png"
                      width="15"
                      height="15"
                      class="absY"
                    />
                    <img
                      v-if="!scope.row.gameData[m].play"
                      src="~@/assets/images/icons/gray_star.png"
                      width="15"
                      height="15"
                      class="absY"
                      style="left:21px"
                    />
                    <img
                      v-if="!scope.row.gameData[m].play"
                      src="~@/assets/images/icons/gray_star.png"
                      width="15"
                      height="15"
                      class="absY"
                      style="left:37px"
                    />
                    <div v-if="scope.row.gameData[m].star == 1">
                      <img
                        src="~@/assets/images/icons/actived_star.png"
                        width="15"
                        height="15"
                        class="absY"
                      />
                    </div>
                    <div v-if="scope.row.gameData[m].star == 2">
                      <img
                        src="~@/assets/images/icons/actived_star.png"
                        width="15"
                        height="15"
                        class="absY"
                      />
                      <img
                        src="~@/assets/images/icons/actived_star.png"
                        width="15"
                        height="15"
                        class="absY"
                        style="left:21px"
                      />
                    </div>
                    <div v-if="scope.row.gameData[m].star == 3">
                      <img
                        src="~@/assets/images/icons/actived_star.png"
                        width="15"
                        height="15"
                        class="absY"
                      />
                      <img
                        src="~@/assets/images/icons/actived_star.png"
                        width="15"
                        height="15"
                        class="absY"
                        style="left:21px"
                      />
                      <img
                        src="~@/assets/images/icons/actived_star.png"
                        width="15"
                        height="15"
                        class="absY"
                        style="left:37px"
                      />
                    </div>
                    <div
                      v-if="
                        scope.row.gameData[m].star == 0 &&
                          scope.row.gameData[m].play
                      "
                    >
                      <img
                        src="~@/assets/images/icons/noStar.png"
                        width="15"
                        height="15"
                        class="absY"
                      />
                      <img
                        src="~@/assets/images/icons/noStar.png"
                        width="15"
                        height="15"
                        class="absY"
                        style="left:21px"
                      />
                      <img
                        src="~@/assets/images/icons/noStar.png"
                        width="15"
                        height="15"
                        class="absY"
                        style="left:37px"
                      />
                    </div>
                  </div>
                </template>
              </el-table-column>
            </div>
          </el-table>
        </div>

        <div v-if="$i18n.locale == 'zh' && userTypeLocal == 2 " class="downloadBtn" @click="downloadData">
          <i class="el-icon-download"></i>
        </div>
      </div>
    </div>

    <div class="bgiOver" v-show="maskBox">
      <div class="over over1">
        <div class="timeout01">{{ $t("timeout01") }}</div>
        <div class="timeout02">{{ $t("timeout02") }}</div>
        <div class="timeout03" @click="cancel()">{{ $t("timeout04") }}</div>
        <div class="timeout04" @click="logOut()">{{ $t("timeout03") }}</div>
      </div>
    </div>

    <div class="bgiOver" v-if="dialogVisible">
      <div class="delCode">
        <i class="el-icon-close" @click="delCode"></i>
      </div>

      <div id="code-area" v-if="temp.codeMode != '0'" class="boxide"></div>
      <div
        id="blocklyDiv"
        v-if="temp.codeMode == '0'"
        class="boxide"
        style="height: 500px; width: 800px;"
      ></div>
    </div>

    <!-- 课程管理 -->
    <div class="bgiOver" v-if="courseMngVisible">
      <div class="courseMng">
        <!-- this.gameList -->
        <div class="courseMngLevel">
          <p>{{ $t("open_or_close_the_courses")}}</p>
        </div>
        <div v-for="gameLevel in courseLevels" class="courseMngLevel" :key="gameLevel">
          <el-button
              v-for="(course, index) in gameList.filter(item => item.gameLevel == gameLevel)"
              :class="lastCourseId && (course.active===undefined || course.active==1) ? 'courseOpen' : 'courseClose'"
              :key="index"
              @click="toggleCourse(course.gameId)"
            >
              {{ $t(course.gameName) }}
            </el-button>
        </div>

        <div class="courseMngLevel" v-if="$i18n.locale == 'zh'">
          <el-checkbox
            v-model="courseVideoOpen"
            :disabled="disabled"
            >解析视频</el-checkbox
          >(关闭后班级内的学生无法查看解析视频)
        </div>

        <div class="courseMngLevel">
          <el-button @click="updateCourseMng()">{{$t("redeemCode_usingBtn")}}</el-button>
          <el-button @click="toggleCourseMng()">{{$t("com_cancel")}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import { mapGetters } from "vuex";
import I18nUtils from "@/utils/i18nUtils";
import { loadScriptsInOrder } from "@/utils/loadScripts";

export default {
  data() {
    return {
      dialogVisible: false,
      changeLangBox: false,
      settingBoxVis: false,
      courseMngVisible: false,

      names: "",
      checked: false,
      courseVideoOpen: true, // 解析视频是否开启
      disabled: false,
      langList: I18nUtils.langList,
      temp: {
        class: "1",
        course: "1001",
        level: "1-10",
        codeMode: "1",
      },

      classId: "", // 当前班级id
      gameId: "", // 当前选中的课程id
      mode: "", // 当前选中的模式
      
      hasClass: true,
      classList: [], // [{"className":"立乐ICODE班","courses":"{1001:1,1002:2}","id":1,"materialId":10012,"materialMode":1,"teacherId":16},
      gameList: [],
      courseLevels: [],
      lastCourseId: 1, // 

      levelList: [
        { id: 1, level: "1-10" },
        { id: 2, level: "11-20" },
        { id: 3, level: "21-30" },
        { id: 4, level: "31-40" },
        { id: 5, level: "41-50" },
        { id: 6, level: "51-60" },
        { id: 7, level: "61-70" },
        { id: 8, level: "71-80" },
        { id: 9, level: "81-90" },
        { id: 10, level: "91-100" },
        { id: 11, level: "101-110" },
        { id: 12, level: "111-120" },
        { id: 13, level: "121-130" },
        { id: 14, level: "131-140" },
        { id: 15, level: "141-150" },
      ],
      newLevelList: [],
      className: "",
      selectGameId: "1001",
      tableData: [],
      firstClass: "",
      firstClassId: "",
      firstCourseId: "1001",
      firstLevel: "1-10",
      userTypeLocal: "",
      workspace: "",
      codeList: [
        { id: "1", name: "Python" },
        { id: "0", name: "Blockly" },
        { id: "2", name: "C++" },
      ],
      courseArr: {},
      maxLevel: [],
      starLevelList: [
        { level: 1 },
        { level: 2 },
        { level: 3 },
        { level: 4 },
        { level: 5 },
        { level: 6 },
        { level: 7 },
        { level: 8 },
        { level: 9 },
        { level: 10 },
      ],
    };
  },

  methods: {

    delCode() {
      this.dialogVisible = false;
    },
  
      // 改变语言
    setLanguage(lang) {
      I18nUtils.setLanguage(this, lang);
    },

    search(val) {
      this.starLevelList = [];
      this.disabled = false;
      this.checked = false;
      this.selectGameId = this.temp.course;
      this.classList.forEach((e) => {
        if (this.temp.class == e.id) {
          this.className = e.className;
        }
      });
      this.gameList.forEach((e) => {
        if (this.temp.course == e.gameId) {
          this.newLevelList = this.getMaxLevel(e.maxLevel);
        }
      });

      if (val !== "1") this.temp.level = "1-10";
      let sLevel = this.temp.level.split("-")[1];
      for (var i = parseInt(sLevel) - 10; i < sLevel; i++) {
        this.starLevelList.push({ level: i + 1 });
      }
      this.searchList(
        this.temp.class,
        this.temp.course,
        this.temp.level.replace(/-/i, ","),
        this.temp.codeMode
      );
    },

    //等级配置
    gameLevelFilter(level) {
      const statusMap = {
        0: 1,
        10: 2,
        20: 3,
        30: 4,
        40: 5,
        50: 6,
      };
      return statusMap[level];
    },

    courseFilter(course) {
      let courseName = this.$t("index_course_" + course.gameId);
      if(courseName == "index_course_" + course.gameId) {
        return course.gameName;
      }
      return courseName;
    },

    getSelectGame(gameId) {
      return this.gameList.find(item => item.gameId == gameId) || {gameId: "1001", gameName: "Course"};
    },

    async getStarCode(item) {
      if (!item.id || this.userTypeLocal == 1) return;
      try {
        this.dialogVisible = true;
        let res = await this.$http.getAxios.get("/class/getGameData", {
          params: {
            id: item.id,
          },
        });
        if (res.data.code == "0") {
          let codeTxt = res.data.data.codeTxt;

          // blockly
          if (this.temp.codeMode == "0") {
            let workspace = Blockly.inject("blocklyDiv", {
              toolbox: document.getElementById("toolbox"),
              grid: { spacing: 20, length: 3, colour: "#ccc", snap: true }, //网格模式
              scrollbars: true,
            });


            this.$nextTick(()=>{

              if (codeTxt == "") {
                workspace.clear();
                return;
              }

              // 如果是JSON格式
              try {
                  let state = JSON.parse(codeTxt);
                  Blockly.serialization.workspaces.load(state, workspace);
                  return;
              } catch (error) {
                  workspace.clear();
              }
              // const codeTxt = Blockly.serialization.workspaces.save(workspace);
              // Blockly.serialization.workspaces.load(codeTxt, workspace);
              
              try {
                  const parser = new DOMParser();
                  const xml = parser.parseFromString(codeTxt, "application/xml").firstChild;

                  Blockly.Xml.domToWorkspace(xml, workspace);
              } catch (error) {
                  workspace.clear();
              }

              workspace.scrollCenter();
            })
          } else {
            // Python
            this.aceText();
            window.editor.setValue(codeTxt);
            window.editor.clearSelection();
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 课程Code支持
    aceText() {
      // 初始化ace编辑器
      this.editor = ace.edit("code-area");
      // 设置主题
      this.editor.setTheme(this.temp.codeMode == "2" ? "ace/theme/solarized_light" : "ace/theme/twilight");
      // 设置语言为python
      this.editor.session.setMode(this.temp.codeMode == "2" ? "ace/mode/c_cpp" : "ace/mode/python");
      this.editor.setReadOnly(true);
      // 允许自动换行
      this.editor.session.setUseWrapMode(true);
      // 设置字体大小
      this.editor.setFontSize("16px");
      // 暴露给window
      window.editor = this.editor;
    },

    getMaxLevel(number) {
      var index = "";
      var index =
        number.toString().length > 1
          ? number.toString().substring(0, number.toString().length - 1)
          : 0;
      if (number.toString().substr(number.toString().length - 1, 1) == 0)
        index =
          number.toString().substring(0, number.toString().length - 1) - 1;
      if (number == 10) index = 0;
      return this.levelList.slice(0, index + 1);
    },

    // 获取课程 班级列表
    async getAllmsgList() {
      try {
        let res = await this.$http.getAxios("/class/getUserClassList");
        if (res.data.code == "0") {
          this.classList = res.data.data;
          if (this.userTypeLocal == 1) {
            this.temp.codeMode = this.classList[0].materialMode;
          }

          if (this.classList.length == 0) {
            this.$message({
              type: "error",
              message: "你还没加入班级，无法查看班级信息",
            });
            this.hasClass = false;
            return;
          }

          this.firstClassId = this.classList[0].id || "";
          this.firstClass = this.classList[0].className || "";
        }

        let courseRes = await this.$http.getAxios("/class/getMaterialList", {
          method: "get",
          params: { mode: this.temp.codeMode },
        });
        if (courseRes.data.code == "0") {
          this.gameList = courseRes.data.data;
          this.courseLevels = this.gameList.map(item => item.gameLevel);
          this.courseLevels = [...new Set(this.courseLevels)]; // unique

          this.firstCourseId = this.gameList[0].gameId || "1001";
          this.newLevelList = this.getMaxLevel(this.gameList[0].maxLevel);
          this.temp.course = this.gameList[0].gameId || 1001;
        }

        if (this.gameList.length > 0 && this.classList.length > 0) {
          // this.searchList();
        }
      } catch (err) {
        console.log(err);
      }
    },

    // 获取对应模式下的课程
    async searchMode() {
      if( !this.hasClass ) return;

      this.disabled = false;
      this.checked = false;
      this.className = "";
      this.selectGameId = "1001";
      this.temp.course = "1001";
      let courseRes = await this.$http.getAxios("/class/getMaterialList", {
        method: "get",
        params: { mode: this.temp.codeMode },
      });
      if (courseRes.data.code == "0") {
        this.gameList = courseRes.data.data;
        this.firstCourseId = this.gameList[0].gameId || "";
        this.searchList(
          this.temp.class,
           // courseRes.data.data[0].gameMode,
           courseRes.data.data[0].gameId,
          // this.temp.course,
          this.temp.level.replace(/-/i, ","),
          this.temp.codeMode
        );
      }
    },

    // 切换查询
    async searchList(classId, gameId, levelIdRange, mode) {
      try {
        if (this.userTypeLocal == 2) {
          var objs = {
            classId: classId,
            gameId: gameId,
            levelIdRange: levelIdRange || "1,10",
            mode: mode,
          };
        } else {
          var objs = {
            levelIdRange: levelIdRange || "1,10",
          };
        }


        let res = await this.$http.getAxios("/class/queryStudentGameData", {
          method: "get",
          params: objs,
        });
        if (res.data.code == "0") {
          this.tableData = res.data.data;
          if (this.tableData.length == 0) return;
          this.tableData.forEach((e) => {
            e.name = e.studentFirstName;
            e.star = e.studentStars + "/" + e.totalStars;
            if (e.gameData.length < 10) {
              let nums = 10 - e.gameData.length;
              for (var i = 0; i < nums; i++) {
                e.gameData.push({ star: 0, play: true });
              }
            }
          });

          // 绑定的信息随之更新
          this.classId = classId;
          this.gameId = gameId;
          this.mode = mode;

        }
      } catch (err) {
        console.log(err);
      }
    },

    // 下载数据
    async downloadData() {
      try {
        await this.$http.getAxios
          .get("/class/exportStudentGameData", {
            headers: { "Content-Type": "multipart/form-data" },
            responseType: "blob",
            params: {
              classId: this.temp.class,
              gameId: this.temp.course,
              mode: this.temp.codeMode,
            },
          })
          .then((res) => {
            let fileName = "class.xlsx";

            if(res.headers["content-disposition"]){
              fileName = decodeURI(
                res.headers["content-disposition"].split(";")[1].split("=")[1]
              );
            }
            let bba = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            // 定义链接
            link.href = bba;
            link.setAttribute("download", fileName);
            // 触发点击
            document.body.appendChild(link);
            link.click();
            // 移除点击
            document.body.removeChild(link);
          });
      } catch (e) {
        this.$notify.error("错误:" + e);
        console.log(e);
      }
    },

    async chooseDefaultCourse() {
      try {
        let res = await this.$http.getAxios("/class/classBindMaterial", {
          method: "get",
          params: {
            id: this.temp.class || this.firstClassId,
            materialId: this.temp.course || this.firstCourseId,
            materialMode: this.temp.codeMode,
          },
        });

        if (res.data.code == "0") {
          this.disabled = true;
          this.$message({
            type: "success",
            message: this.$i18n.t("done"),
          });
        } else {
          this.disabled = false;
          this.checked = false;
          this.$message({
            type: "error",
            message: this.$i18n.t("fail"),
          });
        }
      } catch (err) {
        console.log(err);
      }
    },

    moreLang() {
      this.changeLangBox = !this.changeLangBox;
      this.settingBoxVis = false;
    },
    setting() {
      this.settingBoxVis = !this.settingBoxVis;
      this.changeLangBox = false;
    },

    logOut() {
      this.$http.getAxios.post("/user/logout").then((res) => {
        var res = res.data;
        if (res.code == "0") {
          store.commit("toggleMaskState", false);
          localStorage.removeItem("competeObj");
          localStorage.removeItem("signIn");
          localStorage.removeItem("emailComp");
          this.$router.push({ path: "/" });
        }
      });
    },
    cancel() {
      store.commit("toggleMaskState", false);
    },
    toMyAccount() {
      this.$router.push({ path: "/myAccount" });
    },
    goHome() {
      this.$router.push({ path: "/index" });
    },

    toggleCourseMng(){
      if(this.courseMngVisible) {
        this.courseMngVisible = false;
        return;
      }
      // 打开时请求服务器数据
      this.$http.getAxios("/class/getUserClassList", {
          method: "get",
          params: {
            id: this.classId
          },

        }).then((res)=>{
          if(res.data && res.data.code == '0' && res.data.data && res.data.data[0]){

            let coursesString = res.data.data[0].courses || "{}";
            this.courseOpenMap = JSON.parse(coursesString); // 从API获取课程列表
            this.courseVideoOpen = res.data.data[0].videoOpen != false;

            this.gameList.forEach(course => {
              course.active = this.courseOpenMap[course.gameId]
            })

            this.courseMngVisible = !this.courseMngVisible;
          } else {
            this.$message({
              type: "Error",
              message: "获取班级信息失败",
            });
          }
      })
    },


    updateCourseMng(){

      this.gameList.forEach(course => {
        this.courseOpenMap[course.gameId] = course.active == 0 ? 0 : 1
      });

      this.$http.getAxios("/class/updateClassInfo", {
        method: 'post',
        params: {
          id: this.classId,
          courses: JSON.stringify(this.courseOpenMap),
          videoOpen: this.courseVideoOpen, 
        }
      }).then((res)=>{
        if(res.data.code == '0'){
          this.courseMngVisible = false;
        } else {
          this.$message({
              type: "Error",
              message: "更新班级信息失败",
            });
        }
      })

    },

    toggleCourse(courseId){
      let course = this.gameList.find(item => item.gameId==courseId);
      if (course){
        if(course.active == undefined) course.active = 0; // 默认为开启，所以为undefined
        else {
          course.active = !course.active;
        }
      } 
      this.lastCourseId += 1; // 为了更新，需要watch一个数值
    },

    // 批量管理 todo
    toggleCourses(gameLevel){
      let courses = this.gameList.filter(item => item.gameLevel==gameLevel);
      this.lastCourseId += 1; // 为了更新，需要watch一个数值
    },
  },

  mounted() {
    this.names = localStorage.getItem("names") || "";

    this.userTypeLocal = store.state.userType || localStorage.getItem("userType");

    I18nUtils.initLanguage(this);

    this.getAllmsgList();

    const scriptList = [
      './static/js/blockly/11.1.1/blockly_compressed.js',
      './static/js/blockly/11.1.1/blocks_compressed.js',
      './static/js/blockly/11.1.1/javascript_compressed.js',
      './static/js/blockly/11.1.1/python_compressed.js',
      './static/js/blockly/icode-blocky-lan.js',
      './static/js/blockly/icode_blocks.js',
      './static/lib/ace/ace.js',
    ];

    let lang = this.$i18n.locale;
    if (lang.slice(0, 2) == "en") {//如果是英文则引用英文的js文件
        scriptList.push("./static/js/blockly/en.js");
    } else if(lang == "he") {
        scriptList.push("./static/js/blockly/he.js");
    } else {
        scriptList.push("./static/js/blockly/zh.js");
    }
    loadScriptsInOrder(scriptList);
  },

  async created() {
    let classId
    await this.$http.getAxios("/class/getUserClassList").then((res)=>{
      if(res.data.code == '0'){
        if(res.data.data.length != 0){
          classId = res.data.data[0].id
          this.temp.class = res.data.data[0].id
        }

      }
    })
    await this.$http.getAxios("/class/getMaterialList", {
      method: "get",
      params: { mode: this.temp.codeMode },
    }).then( async (res)=>{
      if(res.data.code == 0){
        // this.classList = res.data.data
        // this.temp.class = res.data.data[0].gameMode
        // this.temp.course = res.data.data[0].gameId
        let objs = {
          classId: classId,
          gameId: res.data.data[0].gameId,
          levelIdRange: "1,10",
          mode: this.temp.codeMode || "1",
        };
         await this.$http.getAxios("/class/queryStudentGameData", {
          method: "get",
          params: objs,
        }).then((res) => {
          if(res.data.code == "0"){
            this.tableData = res.data.data;
            if (this.tableData.length == 0) return;
            this.tableData.forEach((e) => {
              e.name = e.studentFirstName;
              e.star = e.studentStars + "/" + e.totalStars;
              if (e.gameData.length < 10) {
                let nums = 10 - e.gameData.length;
                for (var i = 0; i < nums; i++) {
                  e.gameData.push({ star: 0, play: true });
                }
              }
            });
          }

          // 绑定的信息随之更新
          this.classId = classId;
          this.gameId = res.data.data[0].gameId;
          this.mode = this.temp.codeMode || "1";
        })
      }
    })
  },

  computed: {
    ...mapGetters(["maskBox", "name", "userType"]),
    lan() {
      return this.$i18n.locale;
    },

  },
};
</script>

<style lang="scss" scoped>
.topbar {
  width: 100%;
  height: 60px;
  color: #aaf9fe;
  background: #122346;
  i {
    position: absolute;
    top: 8px;
    left: 40px;
    width: 172px;
    height: 46px;
    cursor: pointer;
    z-index: 99999999999999999;
    background: url("~@/assets/images/bigIcon.png") no-repeat center;
  }
}

.mainBox1 {
  height: 60px;
  position: absolute;
  top: 0;
  right: 20px;
  z-index: 2;
}
.topbar span {
  font-size: 20px;
  line-height: 60px;
  margin-left: 100px;
}
.mainBox {
  // width: 1200px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
.forgetPsd1 {
  margin: 0 auto;
  width: 453px;
  height: 58px;
  background: url("~@/assets/images/title.png") no-repeat center;
  font-size: 38px;
  font-weight: 700;
  text-align: center;
  line-height: 58px;
  color: #37c2e5;
  margin-top: 50px;
}
.signInBox {
  width: 480px;
  padding: 30px 50px 0;
  height: 360px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -290px;
  margin-top: 120px;
  text-align: center;
  padding-bottom: 100px;
}

.moreOption {
  font-size: 16px;
  color: #fff;
  padding: 10px 0 30px;
  span {
    text-decoration: underline;
    padding: 0 10px;
    cursor: pointer;
    &:nth-of-type(1) {
      float: left;
    }
    &:nth-of-type(2) {
      float: right;
    }
  }
}

.changeLangBtn {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  line-height: 60px;
}
.chooseLangUl {
  position: absolute;
  z-index: 111;
  li {
    height: 40px;
    cursor: pointer;
  }
}
.chooseLangUls {
  width: 100%;
  background: #0c355c;
  padding: 0 5px 10px 5px;
  border-radius: 5px;
}
.settingBtn,
.changeLangBtn {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  padding-right: 20px;
}

.settingBtn,
.changeLangBtn {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  padding-right: 20px;
}
.settingBtn {
  padding-right: 0px;
  margin-right: 20px;
  position: relative;
  line-height: 60px;
  min-width: 135px;
  text-align: center;
}
.actSign {
  float: right;
  margin-right: 40px;
  width: 160px;
  height: 39px;
  margin-top: 12px;
  background: url("~@/assets/images/up.png") no-repeat center;
  background-size: cover;
  cursor: pointer;
}
.actSignEn {
  background: url("~@/assets/images/enUp.png") no-repeat center;
  background-size: cover;
}
.chooseLangUl {
  position: absolute;
  z-index: 111;
  li {
    height: 40px;
    cursor: pointer;
  }
}
.over {
  width: 725px;
  height: 467px;
  position: absolute;
  top: 20%;
  background: url("~@/assets/images/timeout.png") no-repeat 1px 2px;
  left: 50%;
  transform: translateX(-50%);
}
.over1 {
  width: 564px;
  height: 458px;
}
.bgiOver {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
}
.timeout01 {
  width: 184px;
  height: 58px;
  position: absolute;
  top: 21px;
  left: 191px;
  z-index: 1;
  text-align: center;
  line-height: 58px;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
}
.timeout02 {
  width: 500px;
  height: 200px;
  position: absolute;
  top: 100px;
  left: 30px;
  text-align: center;
  line-height: 200px;
  color: #fff;
  font-size: 19px;
  font-weight: 700;
}
.timeout03 {
  width: 100px;
  height: 40px;
  position: absolute;
  top: 354px;
  left: 69px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  font-weight: 700;
}
.timeout04 {
  width: 100px;
  height: 40px;
  position: absolute;
  top: 354px;
  left: 400px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  font-size: 23px;
  cursor: pointer;
  font-weight: 700;
}
.star {
  position: relative;
  width: 1200px;
  height: 640px;
  background: url("~@/assets/images/stars.png") no-repeat center;
  background-size: contain;
  margin: 50px auto;

  .defaultCourse {
    position: absolute;
    right: 70px;
    top: 80px;
    color: #fff;
    cursor: pointer;
  }

  .abs {
    position: absolute;
  }

  .title {
    width: 328px;
    height: 40px;
    left: 124px;
    top: 38px;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    .className,
    .courseName {
      height: 100%;
      width: 33%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .classLevels {
      height: 100%;
      width: 25%;
      text-align: right;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .selects {
    width: 198px;
    height: 400px;
    top: 148px;
    left: 4px;
    .cl_list {
      position: absolute;
      top: 0;
      width: 80%;
      height: 40px;
      cursor: pointer;
      left: 50%;
      transform: translateX(-50%);
      .selectsClass {
        width: 100%;
        line-height: 40px;
        text-align: center;
        color: #aaf9fe;

        i {
          line-height: 40px;
          margin: 0 10px;
        }
        .activedColor {
          color: yellow;
        }
        .selectsIcons {
          width: 27px;
          height: 40px;
          background: url("~@/assets/images/icons/class_icon1.png") no-repeat
            center;
          background-size: contain;
        }
        .selectsIconsMode {
          width: 27px;
          height: 40px;
          background: url("~@/assets/images/icons/mode.png") no-repeat center;
          background-size: contain;
        }
        .selectsIcons1 {
          background: url("~@/assets/images/icons/course_icon1.png") no-repeat
            center;
          background-size: contain;
        }
        .selectsIcons2 {
          background: url("~@/assets/images/icons/level_icon1.png") no-repeat
            center;
          background-size: contain;
        }
      }
      .classes {
        background: #0c355c;
        color: #aaf9fe;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
        width: 80%;
        height: 40px;
        opacity: 0;
        border: none;
        outline: none;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        padding-left: 10px;
        cursor: pointer;
      }
      .allClassNames {
        position: absolute;
        width: 56%;
        top: 40px;
        left: 46px;
        color: #fff;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .cl_list0 {
      top: 80px;
    }
    .cl_list1 {
      top: 160px;
    }
    .cl_list2 {
      top: 240px;
    }

    .cl_list3 {
      top: 320px;
    }
    .cl_list4 {
      top: 360px;
    }

    select::-ms-expand {
      display: none;
    }
  }

  .classTables {
    width: 955px;
    height: 436px;
    top: 126px;
    left: 205px;
    border-radius: 10px;
    overflow-y: auto;
  }

  .downloadBtn {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 25px;
    right: 70px;
    width: 60px;
    height: 40px;
    color: #fff;
    cursor: pointer;

    i {
      transform: scale(1.6);
      transition: 0.2s ease;
    }

    &:hover {
      i {
        transform: scale(2);
        color: #0fff;
      }
    }
  }
}
/deep/ .el-table th,
/deep/ .el-table tr {
  background-color: #0c355c !important;
  td {
    border-bottom: 5px solid #002b46;
    border-right: 5px solid #002b46;
    cursor: pointer;
    position: relative;
  }
  i {
    font-size: 20px;
    color: #fff;
  }
  div,
  span {
    color: #fff;
    font-size: 15px;
    letter-spacing: 1px;
  }
}
/deep/ .el-table {
  background: #002b46;
}
/deep/ .el-table th {
  border-right: 5px solid #002b46;
  border-bottom: 5px solid #002b46;
  div {
    color: #fff;
  }
}
/deep/ .el-table--border {
  border: 15px solid #002b46;
  border-radius: 10px;
}
/deep/ .el-table::before {
  height: 0;
}
/deep/ .el-table--border::after {
  height: 0;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #0c355c;
}
/deep/ .cell {
  padding: 0px;
  letter-spacing: 0 !important;
}
.absY {
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
}
.boxide {
  min-height: 500px;
  width: 800px;
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid #ccc;
}
.delCode {
  width: 810px;
  height: 30px;
  background: transparent;
  position: absolute;
  top: calc(10% - 30px);
  left: 50%;
  transform: translateX(-50%);
  i {
    position: absolute;
    color: #ffffff;
    right: 0;
    font-size: 28px;
    cursor: pointer;
  }
}

.courseMng {
  min-width: 1000px;
  max-height: 80%;
  background: #0c355c; 
  border: 2px solid rgb(24,187,197);
  border-radius: 10px;
  padding: 1em;
  overflow: auto;
  
  position: absolute;
  top: calc(10% - 30px);
  left: 50%;
  transform: translateX(-50%);

  .courseMngLevel {
    padding: 1em;
    color: #eee;

    .courseOpen {
      margin: 1px;
      border: none;
      background-color: rgb(24,187,197);
      color: #eee;
    }

    .courseClose {
      margin: 1px;
      border: none;
      background-color: gray;
    }
  }

}
/deep/ .el-checkbox__label {
  font-size: 17px;
}
/deep/ .el-checkbox__label {
  color: #fff;
}
.classTables::-webkit-scrollbar {
  /*width: 0;宽度为0隐藏*/
  width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/star.vue